import { useContext } from 'react';

import { BasketContext, IBasketContext } from './BasketContext';

export const useBasket = (): IBasketContext => useContext(BasketContext);
